import { handleActions } from 'redux-actions';
import { openModal, closeModal, setModalError } from 'actions/modal';

const initialState: any = { title: '', data: {} };

const reducer = handleActions(
  {
    [openModal as any]: (_, action) => action.payload,
    [closeModal as any]: () => initialState,
    [setModalError as any]: (state, action) => {
      return { ...state, data: { ...state.data, error: action.payload.error } };
    },
    '@@router/LOCATION_CHANGE': () => initialState,
  },
  initialState
);

export default reducer;
